module.exports = __webpack_public_path__ + "img/bime.1da6748.webp";